import { SET_ADMISSION_PROCESSES,
  ADD_ADMISSION_PROCESSES,
  ADMISSION_PROCESS_API_REQUEST, 
  ADMISSION_PROCESS_API_SUCCESS, 
  ADMISSION_PROCESS_API_FAILURE, 
} from '../actions/actionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  count: null,
  results: [],
};

export default function admissionProcesses(state = initialState, action) {
  switch (action.type) {
    case SET_ADMISSION_PROCESSES:
      const { count, results } = action.payload;
      return {
        ...state,
        count,
        results,
        loaded: true,
      };
    case ADMISSION_PROCESS_API_REQUEST: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case ADD_ADMISSION_PROCESSES: {
      const { count, results } = action.payload;
      return {
        ...state,
        count,
        results,
        loaded: true,
      };
    }
    
    case ADMISSION_PROCESS_API_SUCCESS: {
      const { count, results } = action.payload;
      return {
        ...state,
        count,
        results,
        loaded: true,
      };
    }
    case ADMISSION_PROCESS_API_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    default:
      return state;
  }
}
